import { Typography } from '@execonline-inc/execonline-ui';
import { LockClosedIcon } from '@heroicons/react/24/outline';
import { T } from '../../../../../../Translations';
import { PluralizedText } from '../../../../../PluralizedText';
import ParticipantRows from './ParticipantRows';

interface Props {
  emails: ReadonlyArray<string>;
}

// Normally these addresses sit among the other people who cannot enroll, in the
// Not licensed group. When nobody in the list resolved to a real person there
// is no such group, and they need a home of their own rather than vanishing.
function UnknownParticipants({ emails }: Props) {
  return (
    <div className="overflow-hidden rounded-md border border-destructive">
      <div className="flex items-start gap-3 p-3">
        <LockClosedIcon className="mt-0.5 h-5 w-5 flex-none text-destructive" aria-hidden="true" />
        <div className="min-w-0 flex-1">
          <Typography variant="subtitleSmall" as="span" fontWeight="semibold">
            <T kind="Not licensed" />
          </Typography>
          <Typography variant="caption" className="mt-1 block text-muted-foreground">
            {emails.length}{' '}
            <PluralizedText count={emails.length} singularKind="person" pluralKind="people" />{' '}
            &middot; <T kind="not in your organization" />
          </Typography>
        </div>
      </div>
      <div className="border-t border-border">
        <ParticipantRows participants={[]} unknownEmails={emails} removable={true} />
      </div>
    </div>
  );
}

export default UnknownParticipants;
